export const isFn = foo => {
  return typeof foo === 'function';
};

export const isTrue = (value = 'false') => {
  if (value === true) {
    return true;
  }
  if (value === null || value === undefined || value === false) {
    return false;
  }
  switch (value.toLowerCase()) {
    case 'true':
    case 'yes':
    case 'y':
    case '1':
    case 'enabled':
      return true;
    default:
      return false;
  }
};

export const undefinedToTrue = value => {
  return value === undefined ? true : value;
};

export const isObjEmpty = obj => {
  return JSON.stringify(obj) === '{}';
};

export const isUndefined = value => {
  return value === undefined;
};



// WEBPACK FOOTER //
// ./src/utils/varValidation.js